<template>
  <div class="inner-card">
    <ValidationObserver v-slot="{ handleSubmit }">
      <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

      <!-- 身分證/護照圖檔＋第二證件圖檔 -->
      <template v-if="images.IsShowIdentityCardFile">
        <h4 style="margin-bottom: 15px">
          <span class="badge bg-warning"> 身分證/護照圖檔＋第二證件圖檔 </span>
        </h4>
        <el-upload
          style="display: inline-block"
          v-if="images.IdentityCardFiles.length < 5"
          class="upload-demo"
          action
          accept=".jpg,.jpeg,.png"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="uploadFile"
          :limit="5"
        >
          <el-button
            size="small"
            type="primary"
            @click="uploadFileType('identityCard')"
          >
            點擊上傳
          </el-button>
        </el-upload>
        <el-button
          v-if="images.IdentityCardFiles.length < 5"
          style="margin-left: 10px"
          size="small"
          type="primary"
          @click="openCamera('identityCard')"
        >
          開啟相機
        </el-button>

        <div
          v-for="(file, index) in images.IdentityCardFiles"
          :key="file.FileGuid + '1'"
        >
          <p
            class="download-file"
            @click="
              $common.downloadFile({
                fileGuid: file.FileGuid,
                fileTitle: file.FileContentType,
              })
            "
          >
            <eva-icon fill="#fff" name="attach-outline" />
            <span class="file-name">
              {{ file.FileName }}
            </span>
            <span
              class="remove-file"
              @click.stop="
                removeFile({
                  fileGuid: file.FileGuid,
                  fileGroupGuid: file.FileGroupGuid,
                  fileTitle: 'identityCard',
                  fileIndex: index,
                })
              "
            >
              <eva-icon fill="#fff" name="trash-2-outline" />
            </span>
          </p>
        </div>
      </template>

      <!-- 畢業證書圖檔 -->
      <template v-if="images.IsShowEducationFile">
        <h4 style="margin-top: 10px; margin-bottom: 15px">
          <span class="badge bg-warning">畢業證書圖檔</span>
        </h4>
        <el-upload
          style="display: inline-block"
          v-if="images.EducationFiles.length < 5"
          class="upload-demo"
          action
          accept=".jpg,.jpeg,.png"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="uploadFile"
          :limit="5"
        >
          <el-button
            size="small"
            type="primary"
            @click="uploadFileType('education')"
          >
            點擊上傳
          </el-button>
        </el-upload>

        <el-button
          v-if="images.EducationFiles.length < 5"
          style="margin-left: 10px"
          size="small"
          type="primary"
          @click="openCamera('education')"
        >
          開啟相機
        </el-button>
        <div v-for="file in images.EducationFiles" :key="file.FileGuid + '2'">
          <p
            class="download-file"
            @click="
              $common.downloadFile({
                fileGuid: file.FileGuid,
                fileTitle: file.FileContentType,
              })
            "
          >
            <eva-icon fill="#fff" name="attach-outline" />
            <span class="file-name">
              {{ file.FileName }}
            </span>
            <span
              class="remove-file"
              @click.stop="
                removeFile({
                  fileGuid: file.FileGuid,
                  fileGroupGuid: file.FileGroupGuid,
                  fileTitle: 'education',
                })
              "
            >
              <eva-icon fill="#fff" name="trash-2-outline" />
            </span>
          </p>
        </div>
      </template>

      <!-- 離職證明圖檔/勞保轉出單 -->
      <template v-if="images.IsShowSeparationFile">
        <h4 style="margin-top: 10px; margin-bottom: 15px">
          <span class="badge bg-warning"> 離職證明圖檔/勞保轉出單 </span>
        </h4>
        <el-upload
          style="display: inline-block"
          v-if="images.SeparationFiles.length < 5"
          class="upload-demo"
          action
          accept=".jpg,.jpeg,.png"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="uploadFile"
          :limit="5"
        >
          <el-button
            size="small"
            type="primary"
            @click="uploadFileType('separation')"
          >
            點擊上傳
          </el-button>
        </el-upload>

        <el-button
          v-if="images.SeparationFiles.length < 5"
          style="margin-left: 10px"
          size="small"
          type="primary"
          @click="openCamera('separation')"
        >
          開啟相機
        </el-button>
        <div v-for="file in images.SeparationFiles" :key="file.FileGuid + '3'">
          <p
            class="download-file"
            @click="
              $common.downloadFile({
                fileGuid: file.FileGuid,
                fileTitle: file.FileContentType,
              })
            "
          >
            <eva-icon fill="#fff" name="attach-outline" />
            <span class="file-name">
              {{ file.FileName }}
            </span>
            <span
              class="remove-file"
              @click.stop="
                removeFile({
                  fileGuid: file.FileGuid,
                  fileGroupGuid: file.FileGroupGuid,
                  fileTitle: 'separation',
                })
              "
            >
              <eva-icon fill="#fff" name="trash-2-outline" />
            </span>
          </p>
        </div>
      </template>

      <!-- 退伍令與免役證明圖檔 -->
      <template v-if="images.IsShowMilitaryFile">
        <h4 style="margin-top: 10px; margin-bottom: 15px">
          <span class="badge bg-warning">退伍令與免役證明圖檔</span>
        </h4>
        <el-upload
          style="display: inline-block"
          v-if="images.MilitaryFiles.length < 5"
          class="upload-demo"
          action
          accept=".jpg,.jpeg,.png"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="uploadFile"
          :limit="5"
        >
          <el-button
            size="small"
            type="primary"
            @click="uploadFileType('military')"
          >
            點擊上傳
          </el-button>
        </el-upload>
        <el-button
          v-if="images.MilitaryFiles.length < 5"
          style="margin-left: 10px"
          size="small"
          type="primary"
          @click="openCamera('military')"
        >
          開啟相機
        </el-button>
        <div v-for="file in images.MilitaryFiles" :key="file.FileGuid + '4'">
          <p
            class="download-file"
            @click="
              $common.downloadFile({
                fileGuid: file.FileGuid,
                fileTitle: file.FileContentType,
              })
            "
          >
            <eva-icon fill="#fff" name="attach-outline" />
            <span class="file-name">{{ file.FileName }}</span>
            <span
              class="remove-file"
              @click.stop="
                removeFile({
                  fileGuid: file.FileGuid,
                  fileGroupGuid: file.FileGroupGuid,
                  fileTitle: 'military',
                })
              "
            >
              <eva-icon fill="#fff" name="trash-2-outline" />
            </span>
          </p>
        </div>
      </template>

      <!-- 身心障礙手冊圖檔 -->
      <template v-if="images.IsShowDisabilityFile">
        <h4 style="margin-top: 10px; margin-bottom: 15px">
          <span class="badge bg-warning">身心障礙手冊圖檔</span>
        </h4>
        <el-upload
          style="display: inline-block"
          v-if="images.DisabilityFiles.length < 5"
          class="upload-demo"
          action
          accept=".jpg,.jpeg,.png"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="uploadFile"
          :limit="5"
        >
          <el-button
            size="small"
            type="primary"
            @click="uploadFileType('disability')"
          >
            點擊上傳
          </el-button>
        </el-upload>
        <el-button
          v-if="images.DisabilityFiles.length < 5"
          style="margin-left: 10px"
          size="small"
          type="primary"
          @click="openCamera('disability')"
        >
          開啟相機
        </el-button>
        <div v-for="file in images.DisabilityFiles" :key="file.FileGuid + '5'">
          <p
            class="download-file"
            @click="
              $common.downloadFile({
                fileGuid: file.FileGuid,
                fileTitle: file.FileContentType,
              })
            "
          >
            <eva-icon fill="#fff" name="attach-outline" />
            <span class="file-name">{{ file.FileName }}</span>
            <span
              class="remove-file"
              @click.stop="
                removeFile({
                  fileGuid: file.FileGuid,
                  fileGroupGuid: file.FileGroupGuid,
                  fileTitle: 'disability',
                })
              "
            >
              <eva-icon fill="#fff" name="trash-2-outline" />
            </span>
          </p>
        </div>
      </template>

      <!-- 戶籍謄本圖檔 -->
      <template v-if="images.IsShowHouseholdFile">
        <h4 style="margin-top: 10px; margin-bottom: 15px">
          <span class="badge bg-warning">戶籍謄本圖檔</span>
        </h4>
        <el-upload
          style="display: inline-block"
          v-if="images.HouseholdFiles.length < 5"
          class="upload-demo"
          action
          accept=".jpg,.jpeg,.png"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="uploadFile"
          :limit="5"
        >
          <el-button
            size="small"
            type="primary"
            @click="uploadFileType('household')"
          >
            點擊上傳
          </el-button>
        </el-upload>
        <el-button
          v-if="images.HouseholdFiles.length < 5"
          style="margin-left: 10px"
          size="small"
          type="primary"
          @click="openCamera('household')"
        >
          開啟相機
        </el-button>

        <div v-for="file in images.HouseholdFiles" :key="file.FileGuid + '6'">
          <p
            class="download-file"
            @click="
              $common.downloadFile({
                fileGuid: file.FileGuid,
                fileTitle: file.FileContentType,
              })
            "
          >
            <eva-icon fill="#fff" name="attach-outline" />
            <span class="file-name">{{ file.FileName }}</span>
            <span
              class="remove-file"
              @click.stop="
                removeFile({
                  fileGuid: file.FileGuid,
                  fileGroupGuid: file.FileGroupGuid,
                  fileTitle: 'household',
                })
              "
            >
              <eva-icon fill="#fff" name="trash-2-outline" />
            </span>
          </p>
        </div>
      </template>

      <!-- 存摺 -->
      <template v-if="images.IsShowBankBookFile">
        <h4 style="margin-top: 10px; margin-bottom: 15px">
          <span class="badge bg-warning">存摺</span>
        </h4>
        <el-upload
          style="display: inline-block"
          v-if="images.BankBookFiles.length < 5"
          class="upload-demo"
          action
          accept=".jpg,.jpeg,.png"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="uploadFile"
          :limit="5"
        >
          <el-button
            size="small"
            type="primary"
            @click="uploadFileType('bankbook')"
          >
            點擊上傳
          </el-button>
        </el-upload>

        <el-button
          v-if="images.BankBookFiles.length < 5"
          style="margin-left: 10px"
          size="small"
          type="primary"
          @click="openCamera('bankbook')"
        >
          開啟相機
        </el-button>
        <div class="row mt-3">
          <div class="col-4">
            <div class="form-group form-inline">
              <label for="" style="color: #fff">銀行代碼</label>
              <el-select
                class="w-100"
                clearable
                placeholder="請選擇"
                v-model="images.BankCode"
              >
                <el-option label="郵局" value="700"></el-option>
                <el-option label="中國信託" value="822"></el-option>
              </el-select>
            </div>
          </div>
          <div class="col-8">
            <div class="form-group form-inline">
              <label for="" style="color: #fff">銀行帳號</label>
              <el-input
                placeholder="請輸入銀行帳號"
                maxlength="20"
                v-model.trim="images.BankAccount"
              />
            </div>
          </div>
        </div>
        <div v-for="file in images.BankBookFiles" :key="file.FileGuid + '7'">
          <p
            class="download-file"
            @click="
              $common.downloadFile({
                fileGuid: file.FileGuid,
                fileTitle: file.FileContentType,
              })
            "
          >
            <eva-icon fill="#fff" name="attach-outline" />
            <span class="file-name">{{ file.FileName }}</span>
            <span
              class="remove-file"
              @click.stop="
                removeFile({
                  fileGuid: file.FileGuid,
                  fileGroupGuid: file.FileGroupGuid,
                  fileTitle: 'bankbook',
                })
              "
            >
              <eva-icon fill="#fff" name="trash-2-outline" />
            </span>
          </p>
        </div>
      </template>

      <!-- 未滿18歲同意書 -->
      <template v-if="images.IsShowUnder18File">
        <h4 style="margin-top: 10px; margin-bottom: 15px">
          <span class="badge bg-warning">未滿18歲同意書</span>
        </h4>
        <ValidationProvider
          ref="Under18Files"
          rules="required"
          v-slot="{ errors }"
        >
          <el-upload
            style="display: inline-block"
            v-if="images.Under18Files.length < 5"
            class="upload-demo"
            action
            accept=".jpg,.jpeg,.png"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="uploadFile"
            :limit="5"
            v-model="images.Under18Files"
            ref=""
          >
            <el-button
              size="small"
              type="primary"
              @click="uploadFileType('under18')"
            >
              點擊上傳
            </el-button>
          </el-upload>

          <el-button
            v-if="images.Under18Files.length < 5"
            style="margin-left: 10px"
            size="small"
            type="primary"
            @click="openCamera('under18')"
          >
            開啟相機
          </el-button>
          <span v-if="errors[0]" class="text-danger">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
        <div v-for="file in images.Under18Files" :key="file.FileGuid + '8'">
          <p
            class="download-file"
            @click="
              $common.downloadFile({
                fileGuid: file.FileGuid,
                fileTitle: file.FileContentType,
              })
            "
          >
            <eva-icon fill="#fff" name="attach-outline" />
            <span class="file-name">{{ file.FileName }}</span>
            <span
              class="remove-file"
              @click.stop="
                removeFile({
                  fileGuid: file.FileGuid,
                  fileGroupGuid: file.FileGroupGuid,
                  fileTitle: 'under18',
                })
              "
            >
              <eva-icon fill="#fff" name="trash-2-outline" />
            </span>
          </p>
        </div>
      </template>

      <!-- 產學合作四方合約書 -->
      <template v-if="images.IsShowIndustryAcademyCooperationFile">
        <h4 style="margin-top: 10px; margin-bottom: 15px">
          <span class="badge bg-warning">產學合作四方合約書</span>
        </h4>
        <el-upload
          style="display: inline-block"
          v-if="images.IndustryAcademyCooperationFiles.length < 5"
          class="upload-demo"
          action
          accept=".jpg,.jpeg,.png"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="uploadFile"
          :limit="5"
        >
          <el-button
            size="small"
            type="primary"
            @click="uploadFileType('industryAcademyCooperation')"
          >
            點擊上傳
          </el-button>
        </el-upload>

        <el-button
          v-if="images.IndustryAcademyCooperationFiles.length < 5"
          style="margin-left: 10px"
          size="small"
          type="primary"
          @click="openCamera('industryAcademyCooperation')"
        >
          開啟相機
        </el-button>
        <div
          v-for="file in images.IndustryAcademyCooperationFiles"
          :key="file.FileGuid + '9'"
        >
          <p
            class="download-file"
            @click="
              $common.downloadFile({
                fileGuid: file.FileGuid,
                fileTitle: file.FileContentType,
              })
            "
          >
            <eva-icon fill="#fff" name="attach-outline" />
            <span class="file-name">{{ file.FileName }}</span>
            <span
              class="remove-file"
              @click.stop="
                removeFile({
                  fileGuid: file.FileGuid,
                  fileGroupGuid: file.FileGroupGuid,
                  fileTitle: 'industryAcademyCooperation',
                })
              "
            >
              <eva-icon fill="#fff" name="trash-2-outline" />
            </span>
          </p>
        </div>
      </template>

      <!-- 既有智財評估 -->
      <template v-if="images.IsShowIPChangeTagFile">
        <h4 style="margin-top: 10px; margin-bottom: 15px">
          <span class="badge bg-warning">既有智財評估</span>
        </h4>
        <el-upload
          style="display: inline-block"
          class="upload-demo"
          action
          accept=".jpg,.jpeg,.png"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="uploadFile"
        >
          <el-button size="small" type="primary" @click="uploadFileType('ip')">
            點擊上傳
          </el-button>
        </el-upload>
        <el-button
          style="margin-left: 10px"
          size="small"
          type="primary"
          @click="openCamera('ip')"
        >
          開啟相機
        </el-button>

        <div
          v-for="file in images.IPChangeTagFiles"
          :key="file.FileGuid + '10'"
        >
          <p
            class="download-file"
            @click="
              $common.downloadFile({
                fileGuid: file.FileGuid,
                fileTitle: file.FileContentType,
              })
            "
          >
            <eva-icon fill="#fff" name="attach-outline" />
            <span class="file-name">{{ file.FileName }}</span>
            <span
              class="remove-file"
              @click.stop="
                removeFile({
                  fileGuid: file.FileGuid,
                  fileGroupGuid: file.FileGroupGuid,
                  fileTitle: 'ip',
                })
              "
            >
              <eva-icon fill="#fff" name="trash-2-outline" />
            </span>
          </p>
        </div>
      </template>

      <!-- 其他 -->
      <template v-if="images.IsShowOtherFile">
        <h4 style="margin-top: 10px; margin-bottom: 15px">
          <span class="badge bg-warning">其他</span>
        </h4>
        <el-upload
          style="display: inline-block"
          class="upload-demo"
          action
          accept=".jpg,.jpeg,.png"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="uploadFile"
        >
          <el-button
            size="small"
            type="primary"
            @click="uploadFileType('other')"
          >
            點擊上傳
          </el-button>
        </el-upload>
        <el-button
          style="margin-left: 10px"
          size="small"
          type="primary"
          @click="openCamera('other')"
        >
          開啟相機
        </el-button>

        <div v-for="file in images.OtherFiles" :key="file.FileGuid + '11'">
          <p
            class="download-file"
            @click="
              $common.downloadFile({
                fileGuid: file.FileGuid,
                fileTitle: file.FileContentType,
              })
            "
          >
            <eva-icon fill="#fff" name="attach-outline" />
            <span class="file-name">{{ file.FileName }}</span>
            <span
              class="remove-file"
              @click.stop="
                removeFile({
                  fileGuid: file.FileGuid,
                  fileGroupGuid: file.FileGroupGuid,
                  fileTitle: 'other',
                })
              "
            >
              <eva-icon fill="#fff" name="trash-2-outline" />
            </span>
          </p>
        </div>
      </template>

      <div class="edit-btn-wrap">
        <!-- 儲存 -->
        <el-button size="mini" @click="handleSubmit(saveImages)">
          儲存
        </el-button>
      </div>
    </ValidationObserver>

    <el-dialog
      title="拍照"
      :visible.sync="cameraVisible"
      width="400px"
      :destroy-on-close="true"
      max
    >
      <vue-web-cam
        ref="webcam"
        height="auto"
        @cameras="onCameras"
        width="100%"
      />

      <el-select
        v-model="currentCameras"
        placeholder="請選擇鏡頭"
        style="width: 100%"
        @change="changeCamera"
      >
        <el-option
          v-for="item in cameras"
          :key="item.deviceId"
          :label="item.label"
          :value="item.deviceId"
        >
        </el-option>
      </el-select>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cameraVisible = false">取 消</el-button>
        <el-button type="primary" @click="onCapture">確定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { WebCam } from "vue-web-cam";

export default {
  props: ["MatchId"],
  name: "Images",

  data() {
    return {
      // 相機
      cameraVisible: false,
      // 相機列表
      cameras: null,
      //目前相機
      currentCameras: null,
      // 上傳圖檔類型
      fileTitle: null,
      // get檔案參數
      resetFileStatus: true,

      images: {
        // 唯一識別碼
        PersonnelInformationId: null,
        // 身分證/護照圖檔＋第二證件圖檔
        IdentityCardFiles: [],
        IsShowIdentityCardFile: false,
        IdentityCardFileGroupId: "",
        // 畢業證書圖檔
        EducationFiles: [],
        IsShowEducationFile: false,
        EducationFileGroupId: "",
        // 離職證明圖檔/勞保轉出單
        SeparationFiles: [],
        IsShowSeparationFile: false,
        SeparationFileGroupId: "",
        // 退伍令與免役證明圖檔
        MilitaryFiles: [],
        IsShowMilitaryFile: false,
        MilitaryFileGroupId: "",
        // 身心障礙手冊圖檔
        DisabilityFiles: [],
        IsShowDisabilityFile: false,
        DisabilityFileGroupId: "",
        // 戶籍謄本圖檔
        HouseholdFiles: [],
        IsShowHouseholdFile: false,
        HouseholdFileGroupId: "",
        // 存摺封面圖檔
        BankBookFiles: [],
        IsShowBankBookFile: false,
        BankBookFileGroupId: "",
        // 未滿18歲同意書
        Under18Files: [],
        IsShowUnder18File: false,
        Under18FileGroupId: "",
        // 產學合作
        IndustryAcademyCooperationFiles: [],
        IsShowIndustryAcademyCooperationFile: false,
        IndustryAcademyCooperationFileGroupId: "",
        // 既有智財評估
        IPChangeTagFiles: [],
        IsShowIPChangeTagFile: false,
        IPChangeTagFileGroupId: "",
        // 其他
        OtherFiles: [],
        IsShowOtherFile: false,
        OtherFileGroupId: "",
      },
    };
  },

  components: {
    "vue-web-cam": WebCam,
  },

  methods: {
    openCamera(type) {
      this.currentCameras = null;
      this.fileTitle = type;
      this.cameraVisible = true;
    },

    onCameras(e) {
      console.log(e);
      this.cameras = e;

      if (this.cameras) {
        if (this.cameras.length > 1) {
          this.$refs.webcam.changeCamera(this.cameras[1].deviceId);
          this.currentCameras = this.cameras[1].deviceId;
        } else {
          this.$refs.webcam.changeCamera(this.cameras[0].deviceId);
          this.currentCameras = this.cameras[0].deviceId;
        }
      }
    },

    changeCamera(val) {
      this.$refs.webcam.changeCamera(val);
    },

    // 拍照
    async onCapture() {
      const base64Data = this.$refs.webcam.capture();

      const base64Response = await fetch(base64Data);
      const blob = await base64Response.blob();
      const file = new File([blob], crypto.randomUUID() + ".jpg", {
        type: "image/jpeg",
      });
      this.uploadFile(file, "isCamera");
      this.cameraVisible = false;
    },
    // 上傳檔案的類型
    uploadFileType(type) {
      this.fileTitle = type;
    },

    // 上傳 檔案
    uploadFile(file, type) {
      const fileSizeMB = file.size / 1024 / 1024;
      const isOther = this.fileTitle === "other";
      const maxSize = isOther ? 10 : 5;

      if (fileSizeMB >= maxSize) {
        this.$notify({
          title: "失敗",
          message: `圖檔大小不得超過${maxSize}MB`,
          type: "error",
          duration: 3500,
        });
        return false;
      }

      this.updateLoading(true);

      let fileGroupGuid;
      switch (this.fileTitle) {
        case "identityCard":
          fileGroupGuid = this.images.IdentityCardFileGroupId;
          break;
        case "education":
          fileGroupGuid = this.images.EducationFileGroupId;
          break;
        case "separation":
          fileGroupGuid = this.images.SeparationFileGroupId;
          break;
        case "military":
          fileGroupGuid = this.images.MilitaryFileGroupId;
          break;
        case "disability":
          fileGroupGuid = this.images.DisabilityFileGroupId;
          break;
        case "household":
          fileGroupGuid = this.images.HouseholdFileGroupId;
          break;
        case "bankbook":
          fileGroupGuid = this.images.BankBookFileGroupId;
          break;
        case "under18":
          fileGroupGuid = this.images.Under18FileGroupId;
          break;
        case "industryAcademyCooperation":
          fileGroupGuid = this.images.IndustryAcademyCooperationFileGroupId;
          break;
        case "ip":
          fileGroupGuid = this.images.IPChangeTagFileGroupId;
          break;
        case "other":
          fileGroupGuid = this.images.OtherFileGroupId;
          break;
      }

      if (fileGroupGuid === null) {
        fileGroupGuid = "";
      }

      let fd = new FormData();

      if (type === "isCamera") {
        fd.append("File", file);
      } else {
        fd.append("File", file.raw);
      }

      fd.append("FileGroupGuid", fileGroupGuid);

      this.$api.file.uploadFile(fd).then((response) => {
        if (response.status === 200) {
          this.updateLoading(false);

          switch (this.fileTitle) {
            case "identityCard":
              this.images.IdentityCardFileGroupId = response.data;
              break;
            case "education":
              this.images.EducationFileGroupId = response.data;
              break;
            case "separation":
              this.images.SeparationFileGroupId = response.data;
              break;
            case "military":
              this.images.MilitaryFileGroupId = response.data;
              break;
            case "disability":
              this.images.DisabilityFileGroupId = response.data;
              break;
            case "household":
              this.images.HouseholdFileGroupId = response.data;
              break;
            case "bankbook":
              this.images.BankBookFileGroupId = response.data;
              break;
            case "under18":
              this.images.Under18FileGroupId = response.data;
              break;
            case "industryAcademyCooperation":
              this.images.IndustryAcademyCooperationFileGroupId = response.data;
              break;
            case "ip":
              this.images.IPChangeTagFileGroupId = response.data;
              break;
            case "other":
              this.images.OtherFileGroupId = response.data;
              break;
          }
          this.resetFileStatus = false;
          this.getFileList(response.data, this.fileTitle);
        }
      });
    },

    // 取得 檔案
    getFileList(fileGroupGuid, fileTitle) {
      this.updateLoading(true);
      this.$api.file
        .getFileDetails({ resetFileStatus: null }, fileGroupGuid)
        .then((response) => {
          if (response.status === 200) {
            switch (fileTitle) {
              case "identityCard":
                this.images.IdentityCardFiles = response.data.filter(
                  (item) => !item.IsDelete
                );
                break;
              case "education":
                this.images.EducationFiles = response.data.filter(
                  (item) => !item.IsDelete
                );
                break;
              case "separation":
                this.images.SeparationFiles = response.data.filter(
                  (item) => !item.IsDelete
                );
                break;
              case "military":
                this.images.MilitaryFiles = response.data.filter(
                  (item) => !item.IsDelete
                );
                break;
              case "disability":
                this.images.DisabilityFiles = response.data.filter(
                  (item) => !item.IsDelete
                );
                break;
              case "household":
                this.images.HouseholdFiles = response.data.filter(
                  (item) => !item.IsDelete
                );
                break;
              case "bankbook":
                this.images.BankBookFiles = response.data.filter(
                  (item) => !item.IsDelete
                );
                break;
              case "under18":
                this.images.Under18Files = response.data.filter(
                  (item) => !item.IsDelete
                );
                break;
              case "industryAcademyCooperation":
                this.images.IndustryAcademyCooperationFiles =
                  response.data.filter((item) => !item.IsDelete);
                break;
              case "ip":
                this.images.IPChangeTagFiles = response.data.filter(
                  (item) => !item.IsDelete
                );
                break;
              case "other":
                this.images.OtherFiles = response.data.filter(
                  (item) => !item.IsDelete
                );
                break;
            }
          }
          this.updateLoading(false);
        });
    },

    // 刪除 檔案
    removeFile({ fileGuid, fileGroupGuid, fileTitle, fileIndex }) {
      this.$api.file.removeFile(fileGuid).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "檔案刪除成功",
            type: "success",
            duration: 2000,
          });
          switch (fileTitle) {
            case "identityCard":
              this.images.IdentityCardFiles.splice(fileIndex, 1);
              break;
            case "education":
              this.images.EducationFiles.splice(fileIndex, 1);
              break;
            case "separation":
              this.images.SeparationFiles.splice(fileIndex, 1);
              break;
            case "military":
              this.images.MilitaryFiles.splice(fileIndex, 1);
              break;
            case "disability":
              this.images.DisabilityFiles.splice(fileIndex, 1);
              break;
            case "household":
              this.images.HouseholdFiles.splice(fileIndex, 1);
              break;
            case "bankbook":
              this.images.BankBookFiles.splice(fileIndex, 1);
              break;
            case "under18":
              this.images.Under18Files.splice(fileIndex, 1);
              break;
            case "industryAcademyCooperation":
              this.images.IndustryAcademyCooperationFiles.splice(fileIndex, 1);
              break;
            case "ip":
              this.images.IPChangeTagFiles.splice(fileIndex, 1);
              break;
            case "other":
              this.images.OtherFiles.splice(fileIndex, 1);
              break;
          }
          this.resetFileStatus = false;
          this.getFileList(fileGroupGuid, fileTitle);
        }
      });
    },

    // 儲存 圖檔繳交
    saveImages() {
      this.$api.onBoard.putImages({ ...this.images }).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "圖檔繳交儲存成功",
            type: "success",
            duration: 2000,
          });
          this.getImages();
        }
        this.updateLoading(false);
      });
    },

    // 取得 圖檔繳交
    getImages() {
      const matchId = this.$route.query.matchId;
      this.updateLoading(true);
      this.$api.onBoard.getImages(matchId).then((response) => {
        if (response.status === 200) {
          this.images = response.data;
        }
        this.updateLoading(false);
      });
    },

    async getData() {
      await this.getImages();
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.file-name {
  margin-left: 15px;
  vertical-align: text-top;
  color: #fff;
}

.download-file {
  margin-top: 20px;
  cursor: pointer;
}

.remove-file {
  display: inline-block;
  position: absolute;
  right: 25px;
}
</style>
